import Footer from './Assets/Footer.js'
import Header from './Assets/Header.js'
import ListCard from './Assets/ListCard.js'
import FilterA from './Assets/FilterA.js'
import FilterPopup from './Assets/FilterPopup.js'
import { useState } from 'react'

function TutorsListPage() {
    let [Click,setClick] = useState(false);
    let ClickHandler = function () {
        setClick(!Click)
    }
    return (
        <>
        <body class={Click ? "TL-body" : ""}>
            <Header/>
            <div class="TL-WholeContainer">
            <aside class="TL-SideBar">
                <FilterA/>
            </aside>
            <main class="TL-Main">
                <div>
                    <div class="TL-TContainer">
                        <h1 class="TL-Title">Tutors List</h1>
                        <div onClick={ClickHandler}>
                            <span class="FilterIcon"></span>
                            <button>Filter</button>
                        </div>
                    </div>
                    <ListCard/>
                    <ListCard/>
                    <ListCard/>
                    <ListCard/>
                    <ListCard/>
                    <ListCard/>
                </div>
                    <FilterPopup Click={Click} Close={ClickHandler}/>
            </main>
        </div>
        <Footer/>
        </body>
        </>
    )
}

export default TutorsListPage